import React from "react";

const CloseDangerIcon = (props: any) => {
  return (
    <svg width={22} height={21} fill="none" {...props}>
      <g clipPath="url(#a)">
        <path
          stroke="red"
          d="m4.677 5.017 11.755 11.816m-11.785-.03L16.462 5.047"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="m1.027.31 20 .052-.051 20-20-.052z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CloseDangerIcon;
